import Reveal from "../components/Reveal";
import PageHeader from "../components/PageHeader";
import { ShieldCheck, Award } from "lucide-react";

const CERTS = [
  { name: "FSSAI", body: "Food Safety and Standards Authority of India — mandatory food business licensing and safety compliance." },
  { name: "APEDA", body: "Agricultural and Processed Food Products Export Development Authority — recognised exporter registration." },
  { name: "IEC", body: "Importer Exporter Code — issued by Director General of Foreign Trade for cross-border trade." },
  { name: "GST", body: "Goods and Services Tax registration — active and compliant tax entity in India." },
  { name: "ISO 22000", body: "International standard for food safety management systems across the supply chain." },
  { name: "HACCP", body: "Hazard Analysis Critical Control Points — systematic preventive food safety framework." },
  { name: "Spices Board of India", body: "Registered exporter under the Ministry of Commerce & Industry, Government of India." },
];

export default function Certifications() {
  return (
    <>
      <PageHeader
        eyebrow="Certifications & Compliance"
        title="Documentation that opens borders."
        italicWord="borders"
        subtitle="A compliant Indian spice exporter carries the paperwork trail international customs authorities and quality-conscious buyers require. Here is ours."
      />

      <section className="py-24 md:py-32 bg-brand-ivory">
        <div className="container-luxe">
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {CERTS.map((c, i) => (
              <Reveal key={c.name} delay={i * 60}>
                <div className="p-8 bg-brand-ivory-warm border border-brand-charcoal/10 hover:border-brand-gold transition-colors h-full">
                  <div className="flex items-center gap-4 mb-6">
                    <div className="w-14 h-14 border border-brand-gold flex items-center justify-center bg-brand-ivory">
                      <ShieldCheck className="w-6 h-6 text-brand-gold" />
                    </div>
                    <div>
                      <div className="font-serif text-2xl text-brand-charcoal leading-none">{c.name}</div>
                      <div className="text-[10px] tracking-[0.28em] uppercase text-brand-charcoal/45 mt-2">Compliance · Available</div>
                    </div>
                  </div>
                  <p className="text-brand-charcoal/65 text-[14.5px] leading-relaxed">{c.body}</p>
                </div>
              </Reveal>
            ))}
          </div>

          <Reveal delay={200} className="mt-16 p-8 md:p-12 bg-brand-green text-brand-ivory border-l-4 border-brand-gold">
            <div className="flex items-start gap-6">
              <Award className="w-8 h-8 text-brand-gold shrink-0 mt-1" />
              <div>
                <div className="overline text-brand-gold-soft">Verification</div>
                <p className="mt-3 text-brand-ivory/85 text-[16px] leading-relaxed max-w-3xl">
                  Relevant certifications, registration documents and Certificates of Analysis are available upon request under a mutual NDA. We are committed to full transparency with serious buyers — please contact our export team for the current documentation pack.
                </p>
              </div>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
